<script>
  import Vue from 'vue';
  import VueResource from 'vue-resource';

  Vue.use(VueResource);

  export default {
    data() {
      return {
        ano: (new Date()).getFullYear(),
        urlImagem: true,
      }
    },
    methods: {
      verificarUrlImagem() {
        Vue.http.get('/img/logo.png')
          .then(() => {
            this.urlImagem = true;
          }).catch(() => {
            this.urlImagem = false;
          });
      }
    },
    computed: {
      
    },
    mounted() {
      this.verificarUrlImagem();
    },
  }
</script>

<template>
  <div class="middle-box text-center loginscreen animated fadeInDown">
    <div style="width:450px;">
      <div v-if="urlImagem">
        <h1 class="logo-name">
          <img src="/img/logo.png" alt="logo empresa">
        </h1>
      </div>
      <div v-else>
        <h1 class="logo-name">
          <img src="/img/logo-gemini.png" alt="logo gemini">
        </h1>
      </div>

      <router-view></router-view>

      <p class="m-t text-white"> <small>Manager &copy; {{ ano }} </small> </p>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/LayoutLogin.vue